import { useState } from "react";
import "./GaLllery.css";
import PhotoAlbum from "react-photo-album";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/thumbnails.css";

import photos from "./photos";

export default function Gallery() {
  const [index, setIndex] = useState(-1);

  return (
    <>
      <div className="container gallery-wrap">
        <h5>Check it out my</h5>
        <h2>Best Projects</h2>
        <PhotoAlbum
          photos={photos}
          layout="masonry"
          onClick={({ index }) => setIndex(index)}
        />

        <Lightbox
          slides={photos}
          open={index >= 0}
          index={index}
          close={() => setIndex(-1)}
          // enable optional lightbox plugins
          plugins={[Fullscreen, Thumbnails, Zoom]}
        />
      </div>
    </>
  );
}
